import apiClient from './client';
import { getFormConfig, getSiteConfig } from './formConfigApi';
import { getDisplayValue } from './displayValue';
import { submitForm } from './submitFormApi';

export { getDisplayValue, apiClient };

export const api = {
  getFormConfig,
  getSiteConfig,
  getDisplayValue,
  submitForm,
};

export default apiClient;
